import { MobiDocument } from './MobiDocument';
import { PointageDetailInoeDocument } from './PointageDetailInoeDocument';

export class Pointage extends MobiDocument {
    private _id: string;
    private _rev: string;
    private _deleted?: boolean; //permet de supprimer un document
    private isInoe: boolean;
    //permet de savoir si le pointage à était envoyer vers Inoe
    private tempsDebut: string;
    private tempsFin: string;
    private datePointage: string; //Format "YYYYMMDD"
    private typePointage: string;
    private idIndividu: number;
    private idInscription: number;
    private tempsSupplementaireId: number;
    private tempsSupplementaireIntitule: string;
    private elementFriseId: number;
    private paletteId: number;
    private groupeId: number;
    private typedoc: string;
    private username: string;
    private pdetail_id: number;

    public constructor(pointage: any) {
        super();
        this._id = pointage._id;
        this._rev = pointage._rev;
        this.isInoe = pointage.isInoe;
        this.tempsDebut = pointage.tempsDebut;
        this.tempsFin = pointage.tempsFin;
        this.datePointage = pointage.datePointage;
        this.typePointage = pointage.typePointage;
        this.idIndividu = pointage.idIndividu;
        this.idInscription = pointage.idInscription;
        this.tempsSupplementaireId = pointage.tempsSupplementaireId;
        this.tempsSupplementaireIntitule = pointage.tempsSupplementaireIntitule;
        this.elementFriseId = pointage.elementFriseId;
        this.paletteId = pointage.paletteId;
        this.groupeId = pointage.groupeId;
        this.typedoc = "pointageANMobi"
        this.username = pointage.username;
        (typeof pointage.pdetail_id !== "undefined")
            ? this.pdetail_id = pointage.pdetail_id
            : this.pdetail_id = -1;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public is_deleted(): boolean | undefined {
        return this._deleted;
    }

    public set_deleted(_deleted: boolean): void {
        this._deleted = _deleted;
    }

    public isIsInoe(): boolean {
        return this.isInoe;
    }

    public setIsInoe(isInoe: boolean): void {
        this.isInoe = isInoe;
    }

    public getTempsDebut(): string {
        return this.tempsDebut;
    }

    public setTempsDebut(tempsDebut: string): void {
        this.tempsDebut = tempsDebut;
    }

    public getTempsFin(): string {
        return this.tempsFin;
    }

    public setTempsFin(tempsFin: string): void {
        this.tempsFin = tempsFin;
    }

    public getDatePointage(): string {
        return this.datePointage;
    }

    public setDatePointage(datePointage: string): void {
        this.datePointage = datePointage;
    }

    public getTypePointage(): string {
        return this.typePointage;
    }

    public setTypePointage(typePointage: string): void {
        this.typePointage = typePointage;
    }

    public getIdIndividu(): number {
        return this.idIndividu;
    }

    public setIdIndividu(idIndividu: number): void {
        this.idIndividu = idIndividu;
    }

    public getIdInscription(): number {
        return this.idInscription;
    }

    public setIdInscription(idInscription: number): void {
        this.idInscription = idInscription;
    }

    public getTempsSupplementaireId(): number {
        return this.tempsSupplementaireId;
    }

    public setTempsSupplementaireId(tempsSupplementaireId: number): void {
        this.tempsSupplementaireId = tempsSupplementaireId;
    }

    public getTempsSupplementaireIntitule(): string {
        return this.tempsSupplementaireIntitule;
    }

    public setTempsSupplementaireIntitule(tempsSupplementaireIntitule: string): void {
        this.tempsSupplementaireIntitule = tempsSupplementaireIntitule;
    }

    public getElementFriseId(): number {
        return this.elementFriseId;
    }

    public setElementFriseId(elementFriseId: number): void {
        this.elementFriseId = elementFriseId;
    }

    public getPaletteId(): number {
        return this.paletteId;
    }

    public setPaletteId(paletteId: number): void {
        this.paletteId = paletteId;
    }

    public getGroupeId(): number {
        return this.groupeId;
    }

    public setGroupeId(groupeId: number): void {
        this.groupeId = groupeId;
    }

    public getTypedoc(): string {
        return this.typedoc;
    }

    public setTypedoc(typedoc: string): void {
        this.typedoc = typedoc;
    }

    public getUsername(): string {
        return this.username;
    }

    public setUsername(username: string): void {
        this.username = username;
    }


    public getPdetail_id(): number {
        return this.pdetail_id;
    }

    public setPdetail_id(pdetail_id: number): void {
        this.pdetail_id = pdetail_id;
    }



}